import gql from 'graphql-tag';

export default gql`
  mutation AuthLoginViaGoogle($token: String!) {
    auth {
      loginViaGoogle(token: $token) {
        ... on OauthToken {
          token
        }
        ... on OauthException {
          code
        }
      }
    }
  }
`;
